import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class GoogleAnalyticsService {

  constructor() { }

  public triggerEvent(eventName: string, eventParams: { [key: string]: any }): void {
    if (typeof gtag !== 'undefined') {
      gtag('event', eventName, eventParams);
    } else {
      console.warn('Google Analytics is not initialized');
    }
  }
}
